/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MembershipAffiliationPriceDto
 */
export interface MembershipAffiliationPriceDto {
    /**
     * 
     * @type {number}
     * @memberof MembershipAffiliationPriceDto
     */
    monthlyPrice: number;
    /**
     * 
     * @type {number}
     * @memberof MembershipAffiliationPriceDto
     */
    trialDays: number;
}

/**
 * Check if a given object implements the MembershipAffiliationPriceDto interface.
 */
export function instanceOfMembershipAffiliationPriceDto(value: object): value is MembershipAffiliationPriceDto {
    if (!('monthlyPrice' in value) || value['monthlyPrice'] === undefined) return false;
    if (!('trialDays' in value) || value['trialDays'] === undefined) return false;
    return true;
}

export function MembershipAffiliationPriceDtoFromJSON(json: any): MembershipAffiliationPriceDto {
    return MembershipAffiliationPriceDtoFromJSONTyped(json, false);
}

export function MembershipAffiliationPriceDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MembershipAffiliationPriceDto {
    if (json == null) {
        return json;
    }
    return {
        
        'monthlyPrice': json['monthlyPrice'],
        'trialDays': json['trialDays'],
    };
}

export function MembershipAffiliationPriceDtoToJSON(json: any): MembershipAffiliationPriceDto {
    return MembershipAffiliationPriceDtoToJSONTyped(json, false);
}

export function MembershipAffiliationPriceDtoToJSONTyped(value?: MembershipAffiliationPriceDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'monthlyPrice': value['monthlyPrice'],
        'trialDays': value['trialDays'],
    };
}

